import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import styled, { css } from "styled-components";
import { fontSizes } from "healthex-common/sizes";
import Dialog from "@mui/material/Dialog";
import { colors } from "healthex-common/colors";
import { HXIconButton } from "./HXButton";
import Close from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { fontWeights } from "healthex-common/weights";
import { FlexColumnDiv } from "./common.styles";
import { multilineEllipsis } from "./base.styles";
export const HXDialog = styled(Dialog) `
    & .MuiDialog-paper {
        padding: 0;
    }

    .MuiDialog-container > .MuiPaper-root:first-child {
        ${(props) => props.width &&
    css `
                width: ${props.width}px;
                min-width: ${props.width}px;
                max-width: ${props.width}px;
            `}

        ${(props) => props.height &&
    css `
                height: ${props.height}px;
                min-height: ${props.height}px;
                max-height: ${props.height}px;
            `}

        ${(props) => props.minHeight &&
    !props.height &&
    css `
                min-height: ${props.minHeight}px;
            `}
    }

    & .MuiDialogTitle-root {
        font-weight: ${fontWeights.SEMI_BOLD};
        padding: 0;
    }

    & .MuiDialogContent-root {
        padding: 0 24px 20px 24px;
        font-size: ${fontSizes.STANDARD};
        line-height: 20px;
        color: black;
        ${(props) => props.height &&
    css `
                height: ${props.height - 56}px;
            `}
    }
`;
export const HXDialogHeader = styled.div `
    width: 100%;
    min-height: 58px;
    padding: 16px 24px 10px 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 8px;
    ${(props) => props.hasBottomBorder &&
    css `
            border-bottom: 1px solid ${colors.black_12};
        `}
`;
export const HXDialogTitleAndSubtitleContainer = styled(FlexColumnDiv) `
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    gap: 4px;
    overflow-wrap: anywhere;
`;
export const HXDialogTitle = styled(DialogTitle) `
    z-index: 1;
    color: ${colors.black_main};
    font-size: ${fontSizes.MEDIUM};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: normal;
    letter-spacing: 0.15px;

    ${(props) => props.maxLines &&
    css `
            ${multilineEllipsis(props.maxLines)}
        `}
`;
export const HXDialogContent = styled(DialogContent) ``;
export const HXDialogActions = styled(DialogActions) `
    padding: 8px 24px 20px 24px;
    ${(props) => props.hasTopBorder &&
    css `
            border-top: 1px solid ${colors.black_12};
            padding: 16px 24px;
        `}

    ${(props) => props.spaceBetweenButtons &&
    css `
            justify-content: space-between;
        `}
`;
const HXDialogCloseButtonEl = styled(HXIconButton) `
    margin-left: auto;
    font-size: 24px !important;
    color: ${colors.black_lighter};
    z-index: 1;
`;
export const HXDialogCloseButton = (props) => {
    return (_jsx(HXDialogCloseButtonEl, { onClick: () => props.onClick(), children: _jsx(Close, {}) }));
};
